import { ReactNode, useState } from 'react'

import { useIntl } from 'react-intl'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import GradientButton from './components/GradientButton'
import LetsMatchedForm from './components/LetsMatchedForm'

const boldText = (chunk: ReactNode[]): ReactNode => (
  <Text
    variant="h5"
    component="span"
    sx={{
      fontSize: IS_NATIVE_APP ? 16 : 18,
      fontWeight: 500,
      color: 'primary.main',
      ...(!IS_NATIVE_APP && { display: 'inline' })
    }}
  >
    {chunk}
  </Text>
)

interface GetMatchedProps {
  defaultShowForm?: boolean
}

const GetMatched = ({ defaultShowForm = false }: GetMatchedProps) => {
  const { formatMessage } = useIntl()
  const [showForm, setShowForm] = useState<boolean>(defaultShowForm)

  return (
    <Stack
      direction="column"
      sx={{
        alignItems: 'center',
        ...(!IS_NATIVE_APP && { pt: 6, pb: 4 }),
        ...(IS_NATIVE_APP && { flex: 1, mt: 4, mb: 4, px: 2 })
      }}
    >
      {!showForm && (
        <>
          <Text variant="h1" component="h2">
            {formatMessage({ defaultMessage: 'Get Matched!' })}
          </Text>

          <Text
            variant="h3"
            component="p"
            sx={{
              color: 'primary.main',
              textAlign: 'center',
              ...(IS_NATIVE_APP && { fontSize: 18 })
            }}
          >
            {formatMessage({
              defaultMessage:
                "Not seeing your part? Don't worry — we've got you covered."
            })}
          </Text>

          <Text
            variant="h5"
            component="p"
            sx={{
              color: 'primary.main',
              fontSize: IS_NATIVE_APP ? 16 : 18,
              mt: 2,
              textAlign: 'center'
            }}
          >
            {formatMessage(
              {
                defaultMessage:
                  "Just hit the <b>Match Me</b> button below and we'll let you know the moment it comes online."
              },
              { b: boldText }
            )}
          </Text>

          <GradientButton
            onClick={() => setShowForm(true)}
            sx={{ mt: 3, width: 120, px: 2.5 }}
          >
            {formatMessage({ defaultMessage: 'Match Me' })}
          </GradientButton>
        </>
      )}

      {showForm && <LetsMatchedForm />}
    </Stack>
  )
}

export default GetMatched
